import { createSlice } from "@reduxjs/toolkit";
import cookie from "react-cookies";


const initialState = {
    status: 'initial',
    statusCoupon: 'initial',
    errorMessage: '',
    plans: [],
    coupons: [],
    couponSingle: [],
    plansPrices: [],
    billings: [],
    selectedPlan: 0,
    selectedPlanPrice: 0,
}

const planReducer = createSlice({
    name: 'plan',
    initialState,
    reducers: {
        loadingPlan(state) {
            state.status = 'loading';
            state.plans = [];
        },
        successPlan(state, action) {
            state.status = 'success';
            state.plans = action.payload.plans;
            state.plans.sort((a,b)=>a.id - b.id);
            if(Array.isArray(action.payload.plans)){
                state.selectedPlan = action.payload.plans.filter(ep=>!ep.name.toLowerCase().includes('free'))[0].id;
            }
            state.plansPrices = action.payload.prices;
            state.selectedPlanPrice = 0;

            state.plansPrices.sort((a,b)=>a.id - b.id);
        },
        changePlanId(state,action){
            state.selectedPlan = action.payload;
            state.selectedPlanPrice = 0;
        },
        changePlanPriceId(state,action){
            state.selectedPlanPrice = action.payload;
        },
        failedPlan(state, action) {
            state.status = 'error';
            state.plans = [];
            state.plansPrices = [];
        },
        loadingBilling(state) {
            state.status = 'loading';
            state.billings = [];
        },
        successBilling(state, action) {
            state.status = 'success';
            state.billings = action.payload;
        },
        filterBilling(state, action) {
            state.status = 'success';
            state.billings =state.billings.filter(ele=>ele.business_name.match(action.payload));
        },
        failedBilling(state, action) {
            state.status = 'error';
            state.billings = [];
        },
        loadingCoupons(state) {
            state.statusCoupon = 'loading';
            state.coupons = [];
        },
        loadingAddCoupon(state) {
            state.statusCoupon = 'loading';
            state.couponSingle = [];
        },
        resetAddCoupon(state) {
            // state.statusCoupon = 'loading';
            state.couponSingle = [];
        },
        successCoupons(state, action) {
            state.statusCoupon = 'success';
            state.coupons = action.payload;
        },
        successCouponsSingle(state, action) {
            state.statusCoupon = 'success';
            state.couponSingle = action.payload;
        },
        failedCoupons(state, action) {
            state.statusCoupon = 'error';
            state.coupons = [];
        },
    },
});

export default planReducer.reducer;

export const { filterBilling,loadingAddCoupon,loadingPlan, successPlan, failedPlan,loadingCoupons,successCoupons,failedCoupons,loadingBilling,successBilling,failedBilling, changePlanId,changePlanPriceId, successCouponsSingle, resetAddCoupon } = planReducer.actions;